const state = {
  isLoginOC: false
};

const getters = {
  oc_user: state => state
};

const actions = {
  setOCLogin({ commit }, obj) {
    commit("setOCLogin", obj);
  }
};

const mutations = {
  setOCLogin(state, obj) {
    state.isLoginOC = obj;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
